var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "section" },
    [
      _vm.page === "subscription"
        ? _c("img", {
            attrs: { src: require("@/assets/img/premium/subscribed.png") },
          })
        : _vm._e(),
      _vm.page === "unsubscription"
        ? _c("img", {
            attrs: { src: require("@/assets/img/premium/unsubscribed.png") },
          })
        : _vm._e(),
      _vm.page
        ? _c("p", [
            _vm._v(_vm._s(_vm.$t(`subscriptionCompleted.${_vm.page}.title`))),
          ])
        : _vm._e(),
      _vm.page
        ? _c("div", { staticClass: "message" }, [
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t(`subscriptionCompleted.${_vm.page}.message1`))
              ),
            ]),
            _c("div", [
              _vm._v(
                _vm._s(_vm.$t(`subscriptionCompleted.${_vm.page}.message2`))
              ),
            ]),
            _c("div", {
              staticClass: "message-note",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t(`subscriptionCompleted.${_vm.page}.message3`)
                ),
              },
            }),
          ])
        : _vm._e(),
      _c(
        "router-link",
        { staticClass: "button-design", attrs: { to: { name: "home" } } },
        [_vm._v(_vm._s(_vm.$t("subscriptionCompleted.backToTop")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }